import { Component, OnInit, OnDestroy  } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { RoleService } from '../../services/role.service';
import { SubsidiaryService } from '../../services/subsidiary.service';

@Component({
    selector: 'app-create-role',
    templateUrl: './create-role.component.html',
    styleUrls: ['./create-role.component.css', '../../app.component.css']
})

export class CreateRoleComponent implements OnInit, OnDestroy {

    roleForm: FormGroup;
    role: any;

    subsidiaries = {};
    subsidiaryInit: any;
    subsidiaryText = '';

    gsSubs: any;

    constructor(private formBuilder: FormBuilder,
                private router: Router,
                private roleService: RoleService,
                private subsidiaryService: SubsidiaryService) {
        this.loadSubsidiaries();
    }

    ngOnInit() {
        this.roleForm = this.formBuilder.group({
            name: ['', Validators.required],
            description: ['', Validators.required],
            subsidiary: ['', Validators.required]
        });
    }

    onSubmitRole() {
        this.role = this.saveRole();

        this.roleService.postRole(this.role).then(res => {
            this.roleForm.reset();

            this.router.navigate(['/roles_jobs', {outlets: {'tab_role': ['roles']}}]);
        });
    }

    saveRole() {
        const currentDate = new Date();

        const roleJson = {
            active: 1,
            createdAt: currentDate,
            description: this.roleForm.get('description').value,
            name: this.roleForm.get('name').value,
            subsidiaryId: this.subsidiaries[this.roleForm.get('subsidiary').value],
            updatedAt: currentDate
        };

        return roleJson;
    }

    loadSubsidiaries() {
        this.gsSubs = this.subsidiaryService.getSubsidiaries().subscribe(tempSubsidiaries => {
            const data = {};

            for (const idx in tempSubsidiaries) {
                data[tempSubsidiaries[idx].name] = null;

                this.subsidiaries[tempSubsidiaries[idx].name] = tempSubsidiaries[idx].id$;
            }

            this.subsidiaryInit = {
                'data': data,
                onAutocomplete: (val) => {
                    // console.log(val);
                    // console.log(this.subsidiaries[val]);
                }
            };
        });
    }

    onBlurSubsidiary() {
        if (this.subsidiaries[this.subsidiaryText] === undefined) {
            this.subsidiaryText = '';
        }
    }

    ngOnDestroy() {
        this.gsSubs.unsubscribe();
    }

}

